// Treatment utility functions

// Utility function to convert treatment title to URL-friendly slug
export const treatmentTitleToSlug = (treatmentTitle) => {
  if (!treatmentTitle) return '';
  
  return treatmentTitle
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
};

// Utility function to convert slug back to display name (for reverse lookup)
export const slugToTreatmentTitle = (slug) => {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
